/*eslint-disable */
var $ = window.jQuery = jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'course-list',
  components: {},
  props: [],
  data() {
    return {
      courses: {},
      categoryList: {},
      categoryFilterName: 'Select Category',
      loader: false
    }
  },
  computed: {
    ...mapGetters([
      'getCategoryList',
      'getProfileInfo'
    ]),
    getCategory() {
      this.categoryList = this.$store.getters.getCategoryList;
      return this.categoryList
    },
    getAllCourses() {
      return this.courses = this.$store.getters.lastestcourses.results
    }
  },
  mounted() {
    this.getCategory,
    this.getAllCourses
  },
  methods: {
    enrollcourse(id) {
      let data = {
        course: id
      }
      this.$store.dispatch('setEnrollNewCourse', data)
        .then((res) => {
          if (res.data.code == '3017') {
            toast.success(res.data.msg);
            this.$store.dispatch('getcourselist').then((res) => {
              return this.courses = this.$store.state.userCourses.latestCourseState.results;
            }).catch((err) => {});
          }
        })
        .catch((err) => {})
    },
    getCoursebyCategory(id, name) {
      this.loader = true;
      if (id != "") {
        this.$router.push('/courses/category/' + id + "/")
        this.$store.dispatch('CourseByCategoryAction', {
          id: id
        }).then((response) => {
          if (response.data.code == '2000') {
            this.loader = false;
            this.courses = this.$store.state.userCourses.couseByCategoryList.courses
            return this.courses;
          }
        })
      } else {
        this.$store.dispatch('getcourselist').then((res) => {
          this.loader = false;
          return this.courses = this.$store.state.userCourses.latestCourseState.results;

        }).catch((err) => {});
      }
      this.categoryFilterName = name;
    }
  },
  watch: {
    getCategory() {
      return this.$store.getters.getCategoryList
    },
    getAllCourses() {
      return this.$store.getters.lastestcourses
    },
  }
}